import { render, staticRenderFns } from "./UpdatePromotion.vue?vue&type=template&id=43716ef2&scoped=true"
import script from "./UpdatePromotion.vue?vue&type=script&lang=js"
export * from "./UpdatePromotion.vue?vue&type=script&lang=js"
import style0 from "./UpdatePromotion.vue?vue&type=style&index=0&id=43716ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43716ef2",
  null
  
)

export default component.exports